import { getAppTexts } from '../appConfig'
import { setTexts } from '../i18n'
import { getCustomTextsData } from './selectors'
import { GetCustomTextsAction } from './actions'
import createMiddleware from 'pmt-modules/redux/createMiddleware'

const getCustomTextsSuccess = createMiddleware(
  GetCustomTextsAction.SUCCESS,
  ({ action, getState, next }) => {
    // finalize action in order to wait it has fully ended (i.e: data is in reducer)
    // so we can use the selectors after that
    next(action)

    // we set the texts after the action has been processed
    // so we can access them from anywhere (especially in "tr" i18n function)
    setTexts(getAppTexts(getState()), getCustomTextsData(getState()))
  }
)

export const customTextsMiddlewares = [getCustomTextsSuccess]
